import angular from 'angular';

// 3rd party deps
import datepickerPopup from 'angular-ui-bootstrap/src/datepickerPopup';
import datepicker from 'angular-ui-bootstrap/src/datepicker';
import timepicker from 'angular-ui-bootstrap/src/timepicker';
import 'bootstrap-ui-datetime-picker';
import ngFileUpload from 'ng-file-upload';
import uiTree from 'angular-ui-tree';
import 'angular-ui-tree/dist/angular-ui-tree.css';

import translation from '../../translation';
import '../../service';
import documentThumbnail from '../documentThumbnail';

export const moduleName = 'recaps.components.fields';
let module = angular.module(moduleName, [
  datepicker,
  datepickerPopup,
  timepicker,
  'ui.bootstrap.datetimepicker',
  ngFileUpload,
  uiTree,
  translation,
  'recaps.services',
  documentThumbnail.name,
]);

export default module;
